module.exports = __webpack_public_path__ + "static/media/1.3.5-dashboard-notifications.307feb59.jpg";